/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Start_AriaInputs */

const en_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Start`)
};

const fr_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au debut`)
};

const de_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Start`)
};

const it_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'inizio`)
};

const ru_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти в меню «Пуск»`)
};

const es_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

const zh_cn2_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回开头`)
};

const ja_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタートへ移動`)
};

const hi_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ पर जाएं`)
};

const pt_pt2_video_export_preview_go_to_start_aria = /** @type {(inputs: Video_Export_Preview_Go_To_Start_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o Início`)
};

/**
* | output |
* | --- |
* | "Go to Start" |
*
* @param {Video_Export_Preview_Go_To_Start_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_start_aria = /** @type {((inputs?: Video_Export_Preview_Go_To_Start_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Start_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_go_to_start_aria(inputs)
	if (locale === "de") return de_video_export_preview_go_to_start_aria(inputs)
	if (locale === "it") return it_video_export_preview_go_to_start_aria(inputs)
	if (locale === "ru") return ru_video_export_preview_go_to_start_aria(inputs)
	if (locale === "es") return es_video_export_preview_go_to_start_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_go_to_start_aria(inputs)
	if (locale === "ja") return ja_video_export_preview_go_to_start_aria(inputs)
	if (locale === "hi") return hi_video_export_preview_go_to_start_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_go_to_start_aria(inputs)
	return en_video_export_preview_go_to_start_aria(inputs)
});